/*
 * File: /src/data/languageNames.js
 * Created Date: Wednesday May 15th 2019
 * Author: Nicolas Wegener
 * -----
 * Last Modified: Wednesday, 15th May 2019 10:12:15 am
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 Assessment Associates Intl
 */
export const LANGUAGE_MAP = {
  chin_simp: 'Chinese',
  cn: 'Chinese',
  zh: 'Chinese',
  'zh-cn': 'Chinese',
  'zh-tw': 'Chinese',
  eng: 'English',
  en: 'English',
  'en-us': 'English',
  greek: 'Greek',
  port: 'Portuguese',
  russ: 'Russian',
  span: 'Spanish',
  fr: 'French',
  fre: 'French',
  thai: 'Thai',
  th: 'Thai',
  jap: 'Japanese',
  ja: 'Japanese',
  'es-mx': 'Spanish (Mexican)',
  vi: 'Vietnamese',
  tr: 'Turkish'
};
